import { useTranslation } from 'react-i18next'
import { MainContentArea } from '@/components/layout/MainContentArea'
import { ContentNavigator } from '@/components/content/ContentNavigator'
import { useContentBundle } from '@/hooks/useContentBundle'
import { useAppStore } from '@/store/appStore'
import { trackPageView } from '@/services/appInsights'
import { AdditionalReadingCategory } from '@/types/api'

export function OverviewPage() {
  const { t } = useTranslation()
  const { data: bundle, isLoading } = useContentBundle()
  const { selectedLanguage, isManualOffline, isTrulyOffline } = useAppStore()

  if (isLoading) {
    return (
      <MainContentArea>
        <div className="loading-state" aria-busy="true">
          {t('content.loadingInLanguage', { language: selectedLanguage.toUpperCase() })}
        </div>
      </MainContentArea>
    )
  }

  if (!bundle) {
    return (
      <MainContentArea>
        <div className="error-state">{t('content.unavailable')}</div>
      </MainContentArea>
    )
  }

  const overviewItems = bundle.additionalReading
    .filter((r) => r.category === AdditionalReadingCategory.Overview)
    .sort((a, b) => a.sortOrder - b.sortOrder)

  const handleItemSelect = (item: { id: number; displayName: string }) => {
    const offlineMode = isManualOffline && isTrulyOffline ? 'both' : isManualOffline ? 'manual' : isTrulyOffline ? 'network' : 'none'
    trackPageView('Overview', `/overview/${item.id}`, {
      additionalReadingId: String(item.id),
      additionalReadingName: item.displayName,
      offlineMode,
    })
  }

  return (
    <MainContentArea>
      <ContentNavigator
        items={overviewItems}
        bundle={bundle}
        emptyMessage={t('pages.noOverviewContent')}
        navLabel={t('pages.overviewNav')}
        onItemSelect={handleItemSelect}
      />
    </MainContentArea>
  )
}
